import { render, staticRenderFns } from "./ChemiFolderForm.vue?vue&type=template&id=179d51e9&"
import script from "./ChemiFolderForm.vue?vue&type=script&lang=ts&"
export * from "./ChemiFolderForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports